/*
  Dolvak · Sepet hediyeleri

  Ürün sayfasında "397 TL değerinde hediye" vaadi var. Rakip (EarClean) bu
  hediyeleri sepette AYRI SATIR olarak gösteriyor; müşteri ne kazandığını
  görüyor. Aynısını yapıyoruz.

  Mantık: sepette ücretli bir ürün varsa 3 hediye otomatik eklenir (adet hep 1),
  ücretli ürün kalmazsa hediyeler de düşer. Hediye satırlarının adet/sil
  düğmeleri cart-drawer.liquid içinde gizlenir, müşteri tek tek kaldıramaz.
*/
(function () {
  var HEDIYE = [49570985541870, 49570985574638, 49570985640174];

  var kendiIstegimiz = false; // kendi çağrılarımızda tekrar tetiklenmeyi engeller
  var calisiyor = false;

  function json(url, govde) {
    var ayar = { method: govde ? 'POST' : 'GET', headers: { Accept: 'application/json' } };
    if (govde) {
      ayar.headers['Content-Type'] = 'application/json';
      ayar.body = JSON.stringify(govde);
    }
    kendiIstegimiz = true;
    return fetch(url, ayar)
      .then(function (r) { return r.json(); })
      .finally(function () { kendiIstegimiz = false; });
  }

  function hediyeMi(kalem) {
    return HEDIYE.indexOf(kalem.variant_id) >= 0;
  }

  function ciz(sonuc) {
    var cekmece = document.querySelector('cart-drawer');
    if (cekmece && sonuc && sonuc.sections) {
      try {
        cekmece.renderContents(sonuc);
        return true;
      } catch (e) { /* aşağıdaki yedek yola düş */ }
    }
    return false;
  }

  function esitle(acilistaMi) {
    if (calisiyor) return Promise.resolve();
    calisiyor = true;

    return json('/cart.js')
      .then(function (sepet) {
        var kalemler = sepet.items || [];
        var ucretliVar = kalemler.some(function (k) { return !hediyeMi(k) && k.price > 0; });
        var mevcut = kalemler.filter(hediyeMi);
        var mevcutIdler = mevcut.map(function (k) { return k.variant_id; });

        // 1) Ücretli ürün yoksa hediyeleri temizle
        if (!ucretliVar) {
          if (!mevcut.length) return null;
          var guncelle = {};
          mevcut.forEach(function (k) { guncelle[k.key] = 0; });
          return json('/cart/update.js', {
            updates: guncelle,
            sections: 'cart-drawer,cart-icon-bubble',
          });
        }

        // 2) Eksik hediyeleri ekle
        var eksik = HEDIYE.filter(function (id) { return mevcutIdler.indexOf(id) < 0; });
        if (eksik.length) {
          return json('/cart/add.js', {
            items: eksik.map(function (id) { return { id: id, quantity: 1 }; }),
            sections: 'cart-drawer,cart-icon-bubble',
          });
        }

        // 3) Adet 1'den farklıysa düzelt (müşteri elle artırmışsa)
        var bozuk = mevcut.filter(function (k) { return k.quantity !== 1; });
        if (bozuk.length) {
          var d = {};
          bozuk.forEach(function (k) { d[k.key] = 1; });
          return json('/cart/update.js', {
            updates: d,
            sections: 'cart-drawer,cart-icon-bubble',
          });
        }

        return null;
      })
      .then(function (sonuc) {
        if (!sonuc) return;
        if (ciz(sonuc)) return;
        // Çekmece yoksa (ör. /cart sayfası) ve açılışta düzeltme yaptıysak tazele
        if (acilistaMi && document.querySelector('.cart__items, #main-cart-items')) {
          window.location.reload();
        }
      })
      .catch(function () { /* sepet hediyesi kritik değil, sessiz geç */ })
      .finally(function () { calisiyor = false; });
  }

  // Temanın sepet çağrılarından sonra devreye gir
  var asilFetch = window.fetch;
  window.fetch = function (girdi, ayar) {
    var adres = typeof girdi === 'string' ? girdi : (girdi && girdi.url) || '';
    // window.dvKopruSessiz: dv-cod.liquid'deki ölçüm köprüsü çalışırken açık; o sırada
    // sepete giren/çıkan satırlar gerçek alışveriş değil, hediye eşitlemesi yapılmaz
    // (20 Eyl 2026 — aksi halde köprüyle ping-pong olup Meta'ya 6 AddToCart gidiyordu).
    var sepetIstegi = !kendiIstegimiz && !window.dvKopruSessiz && /\/cart\/(add|change|update|clear)/.test(adres);
    var sonuc = asilFetch.apply(this, arguments);
    if (sepetIstegi) {
      sonuc.then(function () { setTimeout(function () { esitle(false); }, 60); }).catch(function () {});
    }
    return sonuc;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { esitle(true); });
  } else {
    esitle(true);
  }
})();
